import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import {
  bidOnAuction,
  getUnclaimedBidsByAuctionIndexByBidder,
} from '../util/thunks';

import BidOnAuctionFormUI from './ui/BidOnAuctionFormUI';

class BidOnAuctionForm extends React.Component {

  state = {
    bidAmount: 0,
  };

  componentDidMount() {
    this.updateSuggestedBid();
  }

  updateSuggestedBid = () => {
    let minimumBidIncrement = this.props.web3.utils.toWei('0.01', 'ether');
    let minimumBid = Number(this.props.highestBid) + Number(minimumBidIncrement);
    let suggestedEthBid = this.props.web3.utils.fromWei(minimumBid.toString(), 'ether');
    this.setState({
      bidAmount: suggestedEthBid,
    });
  }

  render() {
    return (
      <BidOnAuctionFormUI
        handleSubmit={this._handleSubmit}
        bidValue={this.state.bidAmount}
        handleBidAmountChange={this._handleBidAmountChange} />
    );
  }

  _handleBidAmountChange = (e) => {

    // Enforce numbers only:
    const bidAmount = (e.target.validity.valid) ? e.target.value : this.state.bidAmount;

    this.setState({
      bidAmount,
    });
  }

  _handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      bidAmount: 0,
    });

    this.props.bidOnAuction(this.props.web3, this.props.auctionIndex, this.state.bidAmount, this.props.accountAddress);
  }

}

const mapStateToProps = (state) => {
  return {
    web3: state.web3.provider,
    accountAddress: state.web3.accounts[0],
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({

  bidOnAuction: (web3, auctionIndex, bidAmount, accountAddress) => {
    dispatch(getUnclaimedBidsByAuctionIndexByBidder([auctionIndex, accountAddress])).then(unclaimedBids => {

      //TODO: Clean up this mess
      // - add form validations in component class (to prevent this in the first place)
      // - add a validation function in each thunk eth call that fails (for analytics)
      //
      // Javascript flopmath is lol, so convert to Wei to do the intmath:
      let bidAmountInWei = web3.utils.toWei(bidAmount.toString(), 'ether');
      let weiBid = bidAmountInWei - unclaimedBids.toNumber();
      let ethBid = web3.utils.fromWei(weiBid.toString(), 'ether');
      let minimumBid = Number(ownProps.highestBid) + Number(web3.utils.toWei('0.01', 'ether'));

      // Enforce minimum bid:
      if (Number(bidAmountInWei) < minimumBid) {
        return toast.error('Must bid Ξ0.01 more than highest bidder.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }

      return dispatch(bidOnAuction([auctionIndex], ethBid));
    });
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(BidOnAuctionForm);



// WEBPACK FOOTER //
// ./src/components/BidOnAuctionForm.js